import React, { PropTypes } from 'react';
import ReactDOM from 'react-dom';
import svg4everybody from 'svg4everybody';

import Home from 'components/sections/Home.jsx';
import Menu from 'components/ui/menu/Menu.jsx';
import { initializeHotUpdate } from 'utils/serverUtils.js';

import 'styles/ab/main.scss';


if (process.env.NODE_ENV !== 'production') {
	// Enable hot updates in development
	initializeHotUpdate();
}

// Add external svg fragment support to IE
svg4everybody();

class AB extends React.Component {
  render() {
    return (
      <div className="application-container">
        <Menu />
        <Home />
      </div>
    );
  }
}

ReactDOM.render( <AB />,  document.getElementById('ab') );
export default AB;



/** WEBPACK FOOTER **
 ** ./src/app/app.jsx
 **/